import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-db61ce0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "workplace-container"
};
import Menu from "@/layout/Menu.vue";
const __default__ = defineComponent({
  name: "myWorkpalce"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const route = useRoute();
    watchEffect(() => {
      console.log("keepalive", route.meta.keepAlive !== true);
    });
    return (_ctx, _cache) => {
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "m-view-workplace"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_container, {
          style: {
            "height": "100%"
          }
        }, {
          default: _withCtx(() => [_ctx.$route.meta.menu ? (_openBlock(), _createBlock(_component_el_aside, {
            key: 0,
            width: "200px",
            style: {
              "border-top-left-radius": "8px"
            },
            class: "menu-aside no-scrollbar"
          }, {
            default: _withCtx(() => [_createVNode(Menu)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_main, {
            id: "workpalce-main",
            class: "no-scrollbar flex-column"
          }, {
            default: _withCtx(() => [_ctx.$route.meta.keepAlive !== true ? (_openBlock(), _createBlock(_component_router_view, {
              key: 0
            })) : (_openBlock(), _createBlock(_component_router_view, {
              key: 1
            }, {
              default: _withCtx(({
                Component
              }) => [(_openBlock(), _createBlock(_KeepAlive, {
                max: 2
              }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
              _: 1
            }))]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});